import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";

export default function CustomerSessionGuard({ children }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let mounted = true;
    let checking = false;

    const verify = async () => {
      if (checking) return;
      checking = true;

      try {
        const response = await fetch("/api/customer/me", {
          credentials: "include",
          cache: "no-store"
        });

        if (!mounted) return;

        if (response.status === 401 || response.status === 403) {
          setStatus("expired");
          navigate("/autentificare", { replace: true });
          return;
        }

        if (response.ok) {
          setStatus("authenticated");
        } else {
          setStatus(previous =>
            previous === "checking" ? "error" : previous
          );
        }
      } catch (error) {
        if (mounted) {
          setStatus(previous =>
            previous === "checking" ? "error" : previous
          );
        }
      } finally {
        checking = false;
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") verify();
    };

    verify();

    const interval = window.setInterval(verify, 15000);
    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("focus", verify);

    return () => {
      mounted = false;
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("focus", verify);
    };
  }, [navigate]);

  if (status === "expired") {
    return <Navigate to="/autentificare" replace />;
  }

  if (status === "checking") {
    return (
      <div className="min-h-screen bg-[#08090c] flex items-center justify-center text-[#d4af37]">
        Se verifică sesiunea...
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="min-h-screen bg-[#08090c] flex flex-col items-center justify-center gap-4 text-white">
        <p>Nu am putut verifica sesiunea. Verifică conexiunea.</p>
        <button
          className="rounded-xl bg-[#d4af37] px-5 py-3 font-semibold text-black"
          onClick={() => window.location.reload()}
        >
          Reîncearcă
        </button>
      </div>
    );
  }

  return children;
}
